<!-- Breadcrumb -->
<div class="mb-[25px] md:flex items-center justify-between">
  <h5 class="!mb-0">
    Rich Text Editor
  </h5>
  <ol class="breadcrumb mt-[12px] md:mt-0">
    <li class="breadcrumb-item inline-block relative text-sm mx-[13px] ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0">
      <a routerLink="/dashboard" class="inline-block relative ltr:pl-[22px] rtl:pr-[22px] transition-all hover:text-primary-500">
        <i class="material-symbols-outlined absolute ltr:left-0 rtl:right-0 !text-lg -mt-px text-primary-500 top-1/2 -translate-y-1/2">
          home
        </i>
        Dashboard
      </a>
    </li>
    <li class="breadcrumb-item inline-block relative text-sm mx-[13px] ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0">
      Forms
    </li>
    <li class="breadcrumb-item inline-block relative text-sm mx-[13px] ltr:first:ml-0 rtl:first:mr-0 ltr:last:mr-0 rtl:last:ml-0">
      Rich Text Editor
    </li>
  </ol>
</div>

<!-- Rich Text Editor -->
<div class="trezo-card bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md">
  <div class="trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between">
    <div class="trezo-card-title">
      <h5 class="!mb-0">
        Ngx Editor
      </h5>
    </div>
  </div>
  <div class="trezo-card-content">
    <div class="NgxEditor__Wrapper">
      @if (editor) {
        <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
        <ngx-editor [editor]="editor"></ngx-editor>
      }
    </div>
  </div>
</div>